import { render } from "./SectionBlock.vue?vue&type=template&id=7f56b5dc&scoped=true"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"

import "./SectionBlock.vue?vue&type=style&index=0&id=7f56b5dc&lang=scss&scoped=true"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f56b5dc"]])

export default __exports__